
































import { Component, Vue, Prop, Ref } from "vue-property-decorator";
import pdf from "vue-pdf";

@Component({
  components: {
    pdf
  }
})
export default class PDFViewer extends Vue {
  @Prop({ required: true }) src: string;
  @Prop({ default: "65vh" }) maxHeight: string;
  @Prop({ default: "30vw" }) width: string;
  @Prop() category: string;
  @Ref() pdfEl: any;

  loadedRatio = 0;
  numPages = 0;
  errMsg = null;

  mounted() {
    this.loadPdf();
  }

  loadPdf() {
    if (this.src) {
      this.loadedRatio = 0;
      const loadingTask = pdf.createLoadingTask(this.src);

      loadingTask.promise
        .then(pdfDoc => {
          console.log("PDF loaded successfully, pages:", pdfDoc);
          this.numPages = pdfDoc.numPages;
        })
        .catch(err => {
          console.error("Error loading PDF:", err);
          this.errMsg = err?.message;
          this.loadedRatio = 1;
        });
    }
  }

  print() {
    this.pdfEl[0].print();
  }

  upload() {
    this.$emit("upload");
  }
}
